module.exports = __webpack_public_path__ + "img/苍南县教育局@2x.3b63e463.png";